var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.9289 3.07106C53.2286 -3.22859 64 1.23309 64 10.1421L64 29C64 34.5228 59.5228 39 54 39L35.1421 39C26.2331 39 21.7714 28.2286 28.0711 21.9289L46.9289 3.07106Z",
    fill: "#15803D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3334 54.3334L10.6667 41.0001M53.3334 54.3334H10.6667V41.0001L53.3334 54.3334ZM53.3334 54.3334V33.0001C53.3334 21.218 43.7822 11.6667 32.0001 11.6667C29.8819 11.6667 27.8361 11.9754 25.9049 12.5502C17.0927 15.1728 10.6667 23.336 10.6667 33.0001V41.0001L53.3334 54.3334Z",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 25V27.6667",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22.3333V24.9999",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 19.6667V22.3334",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrIcon);
export default __webpack_public_path__ + "static/media/br_icon.0fe43131b538d670d99a8978790d01da.svg";
export { ForwardRef as ReactComponent };